import { HTMLAttributes } from 'react';

import { Text, type TypeTextProps } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import { formatNumber } from '~/utils';

import styles from './ProgressCount.module.scss';

type ProgressCountProps = {
  /** 제목 */
  title: string;
  /** 값 */
  value: number;
  /** 총 값 */
  total?: number;
  /** 값 색상
   * @default 'primary' */
  valueColor?: TypeTextProps['color'];
  /** 값이 0일 때 '-' 표시할지 여부
   * @default false */
  showDashIfZero?: boolean;
  /** 커스텀 클래스명 */
  className?: HTMLAttributes<HTMLDivElement>['className'];
};

const ProgressCount = ({
  title,
  value,
  total,
  valueColor = 'primary',
  showDashIfZero = false,
  className,
}: ProgressCountProps) => {
  const numberValue = value === undefined || value === null || Number.isNaN(value) ? 0 : value;

  return (
    <div className={clsx(styles['progress-count'], className)}>
      <Text className={styles['title']} size="small" color="secondary" element="p">
        {title}
      </Text>
      <div className={styles['value-container']}>
        {showDashIfZero && numberValue === 0 ? (
          <Text size="large" weight="semi-bold" element={total ? 'span' : 'p'}>
            {'-'}
          </Text>
        ) : (
          <Text size="large" weight="semi-bold" color={valueColor} element={total ? 'span' : 'p'}>
            {formatNumber(numberValue)}
          </Text>
        )}
        {total && (
          <Text size="large" weight="semi-bold" element="span">
            {`/ ${formatNumber(total)}`}
          </Text>
        )}
      </div>
    </div>
  );
};

export default ProgressCount;
